import { EVENTS } from "@/utils";
import { mapActions, mapState } from "vuex";
import ShowMustLogin from "./components/ShowMustLogin.vue";
import { resetLocalStorage } from "@/utils/storage";
export default {
  name: "App",
  data() {
    return {
      componentKey: 0,
      showMustLogin: false
    };
  },
  components: {
    ShowMustLogin
  },
  mounted() {
    window.$bus.on(EVENTS.SHOW_MUST_LOGIN, () => this.invalidateSession());
    resetLocalStorage();
    //this.socketConnect();
    window.$bus.on(EVENTS.REFRESH_APPLICATION, () => {
      this.forceRerender();
      this.$router.go(0);
    });
    window.$bus.on(EVENTS.MIXPANEL_TRACK, payload => {
      this.trackAction(payload);
    });
  },
  methods: {
    ...mapActions(["mpTrack", "socketConnect"]),
    // Surface the login overlay. Clicking "Login" reloads to the login page,
    // where the expired token is rejected anyway, so no explicit logout is needed.
    invalidateSession() {
      this.showMustLogin = true;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    async trackAction(payload) {
      await this.mpTrack(payload);
    }
  }
};